import React from 'react';

import { LayoutSingleColumn, NamedLink, Page } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import founderPhoto from '../LandingPage/FounderPhoto';

import css from './InfoPage.module.css';

const AboutPage = () => (
  <Page title="About Hotline Glam">
    <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
      <main id="main-content" className={css.page}>
        <section className={css.hero}>
          <div className={css.photoWrap}>
            <img className={css.photo} src={founderPhoto} alt="Chloe Rophael, founder of Hotline Glam" />
          </div>
          <div className={css.copy}>
            <span className={css.eyebrow}>About Hotline Glam</span>
            <h1>Built by a makeup artist who lived the problem.</h1>
            <p className={css.lead}>
              Hotline Glam was founded by Chloe Rophael, a Sydney makeup artist with almost seven years of professional industry experience.
            </p>
            <p>
              After seeing how difficult it could be for clients to find the right artist—and how
              often talented artists had unfilled appointments—I created one place where clients
              could compare artists and request a time without searching profile after profile.
            </p>
            <p>
              I launched Hotline Glam in Sydney with one simple goal: to make last-minute glam
              easier to organise while helping artists turn open appointment times into real bookings.
            </p>
            <div className={css.actions}>
              <NamedLink name="SearchPage" className={css.primary}>Browse Sydney artists</NamedLink>
              <NamedLink name="SignupForUserTypePage" params={{ userType: 'provider' }} className={css.secondary}>
                Join as an artist
              </NamedLink>
            </div>
          </div>
        </section>
      </main>
    </LayoutSingleColumn>
  </Page>
);

export default AboutPage;
